export default __webpack_public_path__ + "static/media/Eater.d426281c.svg";